/**
 * @file recruitment.service.ts
 * @path apps/website/src/features/recruitment/recruitment.service.ts
 */
import { SubmitApplicationPayload } from "./recruitment.types";

export class RecruitmentService {
  /**
   * Converts a File object to a Base64 string.
   */
  static async convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result?.toString().split(",")[1];
        if (base64String) resolve(base64String);
        else reject(new Error("Failed to convert file to Base64"));
      };
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsDataURL(file);
    });
  }

  /**
   * Submits the job application to the Cloud Function.
   */
  static async submitApplication(
    payload: SubmitApplicationPayload,
  ): Promise<void> {
    const response = await fetch(
      "https://europe-west1-sirbastianspro.cloudfunctions.net/submitJobApplication",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: payload }),
      },
    );

    const result = await response.json();

    if (!response.ok || !result.result?.success) {
      throw new Error(result.error?.message || "Failed to submit application");
    }
  }
}
